import SegmentedControl from "@/components/SegmentedControl/SegmentedControl"
import styles from "@/styles/components/ViewToggle.module.css"

/** List or grid, above the customers. */
export type ViewMode = "list" | "grid"

interface ViewToggleProps {
  value: ViewMode
  onChange: (value: ViewMode) => void
}

export default function ViewToggle({ value, onChange }: ViewToggleProps) {
  return (
    <SegmentedControl
      label="Layout"
      value={value}
      onChange={onChange}
      size="sm"
      options={[
        { value: "list", label: <ListGlyph />, title: "List" },
        { value: "grid", label: <GridGlyph />, title: "Grid" },
      ]}
    />
  )
}

function ListGlyph() {
  return (
    <svg className={styles.glyph} viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M2 4h12M2 8h12M2 12h12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

function GridGlyph() {
  return (
    <svg className={styles.glyph} viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <rect x="2" y="2" width="5" height="5" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
      <rect x="9" y="2" width="5" height="5" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
      <rect x="2" y="9" width="5" height="5" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
      <rect x="9" y="9" width="5" height="5" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}
